<template>
  <section class="assessmentSection questionsSection">
    <div class="questionsTopBG"></div>

    <section class="pageContent">
      <div class="pageTitle">Select any smart home features you’re interested in</div>

      <question id="20" lead-key="automationInterests" type="multiple" ref="automationInterests" />

      <!-- Front Door Camera -->
      <transition name="fade">
        <AutomationAdviceBox
          name="Doorbell Camera"
          theKey="FrontDoorCamera"
          plural="Doorbell Cameras"
          :equipment="equipmentByName('Doorbell Camera')"
          v-if="isInterested('Doorbell Camera')"
        >
          <div slot="advice">
            Doorbell cameras can be used on any entry to the home. We recommend adding 1 to the front door.
            <router-link :to="helpEquipmentLink('Doorbell Camera')">Doorbell Camera</router-link>
          </div>
        </AutomationAdviceBox>
      </transition>
      <!-- END Front Door Camera -->

      <!-- Interior Cameras -->
      <transition name="fade">
        <AutomationAdviceBox
          name="Interior Cameras"
          theKey="InteriorCameras"
          plural="Interior Cameras"
          :equipment="equipmentByName('Pulse Indoor Camera')"
          v-if="isInterested('Interior Cameras')"
        >
          <div slot="advice">
            Many homeowners enjoy the benefits of interior cameras by having only 1 camera. The cameras can be moved around and used for multi-purpose. To discover different ways to use the camera, check out camera guide in our
            <img src="/img/help-icon.png" alt="Help Icon" /> help section.
            <router-link :to="helpEquipmentLink('Pulse Indoor Camera')">Camera Guide</router-link>
          </div>
        </AutomationAdviceBox>
      </transition>
      <!-- END Interior Cameras -->

      <!-- Remote Door Locks -->
      <transition name="fade">
        <AutomationAdviceBox
          name="Remote Door Locks"
          theKey="RemoteDoorLocks"
          plural="Remote Door Locks"
          :equipment="equipmentByName('Kwikset Remote Door Lock')"
          v-if="isInterested('Remote Door Locks')"
        >
          <div slot="advice">
            We find most people get the most benefit from remote doors locks by installing 1 on the most used door. Check out our door lock help guide in the
            <img src="/img/help-icon.png" alt="Help Icon" /> help section.
            <router-link :to="helpEquipmentLink('Kwikset Remote Door Lock')">Door Lock Guide</router-link>
          </div>
        </AutomationAdviceBox>
      </transition>

      <!-- END Remote Door Locks -->

      <!-- Smart Thermostat -->
      <transition name="fade">
        <AutomationAdviceBox
          name="Smart Thermostat"
          theKey="SmartThermostat"
          plural="Smart Thermostats"
          :equipment="equipmentByName('Smart Thermostat')"
          v-if="isInterested('Smart Thermostat')"
        >
          <div slot="advice">
            Most of our customers prefer the NEST thermostat. You do have the option of choosing a different smart thermostat from the ones we offer. Learn about our thermostats in the
            <img src="/img/equipment-info-icon.png" alt /> Equipment section.
            <router-link :to="helpEquipmentLink('Smart Thermostat')">Smart Thermostats</router-link>
          </div>
        </AutomationAdviceBox>
      </transition>
      <!-- END Smart Thermostat -->

      <!-- Lighting Control -->
      <transition name="fade">
        <AutomationAdviceBox
          name="Lighting Control"
          theKey="LightingControl"
          plural="Lighting Control Units"
          :equipment="equipmentByName('Lamp Module')"
          v-if="isInterested('Lighting Control')"
        >
          <div slot="advice">NEED CONTENT HERE</div>
        </AutomationAdviceBox>
      </transition>
      <!-- END Lighting Control -->

      <continue-button :before="mixpanelTracking" to="/assessment/environmental" />
      <div class="startOverSection text-center">
        <a
          href="/assessment/start-over"
          onclick="mixpanel.track('startedOver')"
        >Clear data and start over</a>
      </div>
    </section>
  </section>
</template>


<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AutomationAdviceBox from "../components/InterestedEquipment.vue";
export default {
  components: {
    AutomationAdviceBox
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["lead", "automationInterestsMore", "equipment"]),

    ...mapGetters(["equipmentByName"])
  },
  methods: {
    ...mapActions(["removeAutomationInterest"]),

    isInterested(name) {
      return this.lead.automationInterests.includes(name);
    },

    helpEquipmentLink(name) {
      let slug = encodeURI(name);
      return `/assessment/help/equipment?name=${slug}`;
    },

    mixpanelTracking() {
      let qtys = this.lead.automationQuantities;
      let data = {
        P_SH_FrontdoorCameraQuantity: qtys.FrontDoorCamera,
        P_SH_InteriorCameraQuantity: qtys.InteriorCameras,
        P_SH_remoteDoorLockQuantity: qtys.RemoteDoorLocks,
        P_SH_smartThermostatQuantity: qtys.SmartThermostat,
        P_SH_lightingControlQuantity: qtys.LightingControl
      };
      mixpanel.track("completedSmartHomeSection", data);
      mixpanel.people.set(data);
    }
  },

  mounted() {
    this.$Progress.set(56);
  }
};
</script>
